<template>
  <cui-acl :roles="['TalkmoreB2CReportManager', 'TalkmoreB2CReport']" v-if="loaded">
    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; align-items: center">
      <h4>Talkmore B2C<br>Rapport</h4>
      <a-form-item label="Avdeling" v-if="['TalkmoreB2CReportManager'].some(r => $store.state.user.roles.indexOf(r) >= 0)">
        <a-select
          ref="select"
          v-model="department"
          :options="options1"
          style="width: 60%"
          @change="onChangeDep"
        ></a-select>
      </a-form-item>
      <a-form-item label="Periode" v-if="['TalkmoreB2CReportManager'].some(r => $store.state.user.roles.indexOf(r) >= 0)">
        <a-range-picker @change="onChange"  :value="dateRange" />
      </a-form-item>
    </div>
    <div class="row">
      <div class="cui__utils__heading">
        <strong>Salg / Budsjett</strong>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-xl-4">
        <div class="card text-white bg-primary">
          <kit-general-12v1 title="Salg i dag" :reached="todayKPI.nsales" :budget="todayKPI.budget"/>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card text-white bg-primary">
          <kit-general-12v1 title="Salg denne uken" :reached="weekKPI.nsales" :budget="weekKPI.budget"/>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card text-white bg-primary">
          <kit-general-12v1 title="Salg denne måneden" :reached="monthKPI.nsales" :budget="monthKPI.budget"/>
        </div>
      </div>
    </div>
    <div class="cui__utils__heading">
      <strong>Best selger</strong>
      <!-- <a-range-picker @change="onChange"  style="float: right;" :value="dateRange" /> -->
    </div>
    <div class="row">
      <div class="col-lg-4" v-if="sellers[0]">
        <div class="card bg-primary">
          <div class="card-body">
            <seller-prize
            :name="sellers[0].name"
            :imgUrl="sellers[0].imagUrl"
            :isDark="true"
            :data="[
            {
              label: 'Poeng',
              value: sellers[0].monthPoints,
            },
            {
              label: 'Salg',
              value: sellers[0].monthSales,
            },
            ]"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-4" v-if="sellers[1]">
        <div class="card bg-light">
          <div class="card-body">
            <seller-prize
            :name="sellers[1].name"
            :imgUrl="sellers[1].imagUrl"
            :data="[
            {
              label: 'Poeng',
              value: sellers[1].monthPoints,
            },
            {
              label: 'Salg',
              value: sellers[1].monthSales,
            },
            ]"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-4" v-if="sellers[2]">
        <div class="card bg-white">
          <div class="card-body">
            <seller-prize
            :name="sellers[2].name"
            :imgUrl="sellers[2].imagUrl"
            :data="[
            {
              label: 'Poeng',
              value: sellers[2].monthPoints,
            },
            {
              label: 'Salg',
              value: sellers[2].monthSales,
            },
            ]"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12" v-if="sellers[3]">
      <a-table :data-source="sellers.filter((x,i) => i>2)" :columns="columns"/>
    </div>
    <div v-if="['TalkmoreB2CReportManager'].some(r => $store.state.user.roles.indexOf(r) >= 0)">
      <div class="row">
        <div class="cui__utils__heading">
          <strong>Sett Budsjett</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <h4>Dagens budsjett</h4>
          <editable-cell :text="String(todayKPI.budget)" @change="onCellChange('todayKPI.budget', $event)" />
        </div>
        <div class="col-md-4">
          <h4>Ukes budsjett</h4>
          <editable-cell :text="String(weekKPI.budget)" @change="onCellChange('weekKPI.budget', $event)" />
        </div>
        <div class="col-md-4">
          <h4>Månedens budsjett</h4>
          <editable-cell :text="String(monthKPI.budget)" @change="onCellChange('monthKPI.budget', $event)" />
        </div>
      </div>
    </div>
  </cui-acl>
</template>

<script>
import KitGeneral12v1 from '@/components/kit/widgets/General/12v1'
import SellerPrize from '@/components/custom/visual/sellerprize'
import EditableCell from '@/components/custom/visual/editableCell'
import cuiAcl from '@/components/cleanui/system/ACL'

import * as firebase from 'firebase/app'
import 'firebase/firestore'
import moment from 'moment'

import data from './data.json'

const tableColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Position',
    dataIndex: 'position',
    key: 'position',
  },
  {
    title: 'Age',
    dataIndex: 'age',
    key: 'age',
    sorter: (a, b) => a.age - b.age,
  },
  {
    title: 'Office',
    dataIndex: 'office',
    key: 'office',
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'Salary',
    dataIndex: 'salary',
    key: 'salary',
    sorter: (a, b) => a.salary - b.salary,
  },
]

export default {
  components: {
    KitGeneral12v1,
    SellerPrize,
    EditableCell,
    cuiAcl,
  },
  data() {
    return {
      options1: [
        {
          value: 'all',
          label: 'Alle avdelinger',
        },
        {
          value: 'TRD',
          label: 'Trondheim',
        },
        {
          value: 'KRS',
          label: 'Kristiansand',
        },
        {
          value: 'TOS',
          label: 'Tromsø',
        },
      ],
      department: 'all',
      tableData: data.tableData,
      tableColumns,
      dateRange: [
        moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'YYYY/MM/DD'),
        moment(new Date(), 'YYYY/MM/DD'),
      ],
      sales: [],
      todayKPI: {},
      monthKPI: {},
      loaded: false,
      variables: {},
      sellers: [],
      columns: [
        {
          title: 'Plass',
          dataIndex: 'key',
          key: 'position',
        },
        {
          title: 'Selger',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Salg',
          dataIndex: 'monthSales',
          key: 'monthSales',
        },
        {
          title: 'Poeng',
          dataIndex: 'monthPoints',
          key: 'monthPoints',
        },
      ],
    }
  },
  methods: {
    moment,
    onChange(date, dateString) {
      console.log(date, dateString)
      this.dateRange = date
      this.getData()
    },
    onChangeDep(value) {
      this.department = value
      this.getData()
    },
    onCellChange(key, value) {
      if (key === 'todayKPI.budget') {
        this.todayKPI.budget = Number(value)
        this.variables.budget.day = Number(value)
      }
      if (key === 'weekKPI.budget') {
        this.weekKPI.budget = Number(value)
        this.variables.budget.week = Number(value)
      }
      if (key === 'monthKPI.budget') {
        this.monthKPI.budget = Number(value)
        this.variables.budget.month = Number(value)
      }
      firebase.firestore().collection('variables').doc('tmb2c')
        .update(this.variables)
      this.$forceUpdate()
    },
    async getData() {
      const start = new Date(this.dateRange[0])
      const end = new Date(this.dateRange[1])
      let sellers = []
      await firebase.firestore().collection('variables').doc('tmb2c').get()
        .then(doc => {
          this.variables = doc.data()
          return firebase.firestore().collection('users').where('status', '==', 'active').orderBy('fullName').orderBy('talkmoreB2C').get()
        }).then(snapshot => {
          snapshot.forEach(doc => {
            const seller = {
              id: doc.data().employeeID,
              name: doc.data().fullName,
              department: doc.data().department,
            }
            sellers.push(seller)
          })
          return firebase.firestore().collection('tmb2c-sales').where('dateCreated', '>', start).where('dateCreated', '<', end).orderBy('dateCreated', 'asc').get()
        }).then(snapshot => {
          this.sales = []
          const today = moment().format('YYYY-MM-DD')
          snapshot.forEach(doc => {
            const sale = doc.data()
            sale.id = doc.id
            sale.dateCreated = moment(doc.data().dateCreated.toDate()).format('YYYY-MM-DD')
            this.sales.push(sale)
          })
          console.log(sellers)
          sellers.forEach((seller, i) => {
            sellers[i].monthSales = 0
            sellers[i].monthPoints = 0
          })
          const todayKPI = {
            nsales: 0,
            budget: this.variables.budget.day,
          }
          const weekKPI = {
            nsales: 0,
            budget: this.variables.budget.week,
          }
          const monthKPI = {
            nsales: 0,
            budget: this.variables.budget.month,
          }
          this.sales.forEach(sale => {
            const i = sellers.findIndex(x => x.id === sale.seller.id)
            if (i >= 0) {
              if (this.department === 'all' | sellers[i].department === this.department) {
                if (sale.status === '01 registered') {
                  let nSub = 1
                  if (sale.children) {
                    nSub += sale.children.length
                  }
                  if (sale.dateCreated === today) {
                    todayKPI.nsales += nSub
                  }
                  if (sale.dateCreated.substring(0, 7) === today.substring(0, 7)) {
                    sellers[i].monthSales += nSub
                    sellers[i].monthPoints += sale.points
                    sellers[i].monthPoints = Math.round(sellers[i].monthPoints * 100) / 100
                    monthKPI.nsales += nSub
                  }
                  if (Number(moment(sale.dateCreated).week()) === Number(moment(today).week())) {
                    weekKPI.nsales += nSub
                  }
                }
              }
            } else {
              console.log(sale)
            }
          })
          sellers.sort((a, b) => b.monthPoints - a.monthPoints)
          sellers = sellers.filter((value, index, self) =>
            index === self.findIndex((t) => t.monthSales !== 0 && t.name === value.name),
          )
          let c = 1
          sellers.forEach((seller, i) => {
            sellers[i].key = c
            c += 1
          })
          this.sellers = sellers
          this.todayKPI = todayKPI
          this.weekKPI = weekKPI
          this.monthKPI = monthKPI
          this.loaded = true
        })
    },
  },
  mounted() {
    this.getData()
  },
}
</script>
